import { render, staticRenderFns } from "./residentialQuartersDetail.vue?vue&type=template&id=53a23adc&scoped=true&"
import script from "./residentialQuartersDetail.vue?vue&type=script&lang=js&"
export * from "./residentialQuartersDetail.vue?vue&type=script&lang=js&"
import style0 from "./residentialQuartersDetail.vue?vue&type=style&index=0&id=53a23adc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a23adc",
  null
  
)

export default component.exports